<template>
  <v-dialog
    v-model="open"
    max-width="480"
    persistent
    scrollable
    transition="dialog-bottom-transition"
  >
    <v-card class="rounded-lg">
      <v-card-title class="d-flex align-center pa-4 reauth-header">
        <v-icon color="white" class="mr-2">mdi-google</v-icon>
        <span class="white--text">Reconectar com o Google</span>
      </v-card-title>

      <v-card-text class="ds-dialog-body">
        <section class="ds-form-section">
          <div class="text-body-1 mb-2">
            {{ message }}
          </div>
          <div class="text-caption grey--text">
            Você será levado ao Google para conceder as permissões necessárias
            ao Calendar. Depois disso, sua agenda volta a funcionar normalmente.
          </div>
        </section>
      </v-card-text>

      <v-card-actions class="ds-dialog-actions">
        <v-btn outlined color="primary" :disabled="loading" @click="dismiss">
          Agora não
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          depressed
          :loading="loading"
          @click="reconnect"
        >
          <v-icon small left>mdi-link-variant</v-icon>
          Reconectar agora
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import http from "@/services/http";

export default {
  name: "GoogleReauthDialog",

  data() {
    return {
      open: false,
      loading: false,
      message:
        "Sua conta Google precisa ser reconectada para acessar o Calendar.",
      reauthUrl: "/api/auth/google/redirect",
    };
  },

  mounted() {
    window.addEventListener("reauth-google-needed", this.handleReauth);
  },

  beforeDestroy() {
    window.removeEventListener("reauth-google-needed", this.handleReauth);
  },

  methods: {
    handleReauth(event) {
      // Se já está aberto, ignora — evita re-abrir em cascata
      if (this.open) return;

      const detail = event.detail || {};
      if (detail.message) this.message = detail.message;
      if (detail.reauthUrl) this.reauthUrl = detail.reauthUrl;
      this.open = true;
    },

    dismiss() {
      this.open = false;
    },

    async reconnect() {
      this.loading = true;
      try {
        const { data } = await http.get(this.reauthUrl);
        if (data?.redirect_url) {
          window.location.assign(data.redirect_url);
          return;
        }
        throw new Error("URL de redirecionamento não recebida do servidor");
      } catch (err) {
        console.error("Erro ao iniciar reconexão Google:", err);
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.reauth-header {
  background: linear-gradient(135deg, #4285f4 0%, #34a853 100%);
}
</style>
